import { BankMandateType } from '@/graphql';

const bankMandateTypes: { [K in BankMandateType]: string } = {
  [BankMandateType.A]: 'A-Vollmacht',
  [BankMandateType.B]: 'B-Vollmacht',
  [BankMandateType.E]: 'Einzelvollmacht',
};

export default bankMandateTypes;
